import { render, staticRenderFns } from "./DeleteRecordModal.vue?vue&type=template&id=5c5cc543&scoped=true&"
import script from "./DeleteRecordModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRecordModal.vue?vue&type=style&index=0&id=5c5cc543&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cc543",
  null
  
)

export default component.exports